export const CHECKBOX_TYPE_DEFAULT = 'default'
export const CHECKBOX_TYPE_SWITCH = 'switch'
